module.exports = __webpack_public_path__ + "static/media/loading.68230cb0.gif";